<template>
  <div class="river-index">
    <navigation :customClickEvent="true" @click="detention">
      优选借款
      <template #right>
        <img
          src="./images/icon_kefu@2x.png"
          class="service-icon"
          @click="$router.push('/service')"
        />
      </template>
    </navigation>
    <pulldown-page
      :refresh="onRefresh"
      :is-scroll="true"
      background="#FAFAFA"
      color="#333333"
    >
      <van-swipe
        v-if="bannerList.length > 0"
        :autoplay="3000"
        :duration="500"
        class="banner"
      >
        <van-swipe-item
          v-for="(item, index) in bannerList"
          :key="index"
          @click="jumpOutLink(item)"
          :data-sensors-exposure-property-product_code="item.config?item.config.configId:''"
          data-sensors-exposure-property-element_positon="product_banner"
          data-sensors-exposure-property-product_type="diversion"
          data-sensors-exposure-event-name="Diversion_Exposure" 
        >
          <img :src="item.icon || item.bannerUrl" :alt="item.content" /> 
        </van-swipe-item>
        <div v-if="bannerList.length > 1" slot="indicator" class="indicator">
          <div
            v-for="(item, index) in bannerList"
            :key="index"
            class="indicator-item"
          />
        </div>
      </van-swipe>

      <div class="tab-container">
        <div
          :class="['item', { active: tabActive == 0 }]"
          @click="tabActive = 0"
        >
          <i class="icon"></i>优选产品
        </div>
        <div
          :class="['item', { active: tabActive == 1 }]"
          @click="tabActive = 1"
        >
          <i class="icon"></i>已申请产品
        </div>
      </div>
      <div class="tab1" v-if="tabActive === 0">
        <quick-list :list="quickList" position="river_diversion"></quick-list>
        <div class="river" v-if="borrowList && borrowList.length > 0">
          <div class="borrow">
            <main>
              <p class="title">精选推荐 <span>连续申请多家，成功率可达<font class="red">90%</font>以上</span></p>
              <div
                v-for="(item, index) in borrowList"
                :key="index"
                class="item"
                @click="borrowMoney(item, index)"
                :data-sensors-exposure-property-product_code="item.configId"
                data-sensors-exposure-property-element_positon="product_list"
                data-sensors-exposure-property-product_type="diversion"
                data-sensors-exposure-event-name="Diversion_Exposure" 
              >
                <div class="top">
                  <div class="top-left">
                    <img :src="item.icon" />
                    <span class="top-left-more">{{ item.productName }}</span>
                    <div
                      class="top-left-border"
                      v-for="(item, index) in dealWorld(item.cornerWord)"
                      :key="index"
                    >
                      {{ item }}
                    </div>
                  </div>
                  <div class="top-right">
                    <span class="red">{{ item.loanCounts }}</span>人已借款
                  </div>
                </div>
                <div class="bottom">
                  <div class="configLimit">
                    <div class="bottom-left-limit">额度高达 (元)</div>
                    <div class="flex-center">
                      <div class="bottom-left-money">
                        {{ item.configLimit | currency }}
                      </div>
                    </div>
                  </div>
                  <div class="minPrice">
                    <div class="bottom-left-label">
                      <span>年化利率</span>
                      <p>{{ item.minPrice }}%-{{
                        item.maxPrice
                      }}%</p>
                      <!-- <span>期限{{ item.minTerms }}-{{ item.terms }}个月</span> -->
                    </div>
                  </div>
                  <div class="bottom-right">{{ item.buttonName }}</div>
                </div>
              </div>
            </main>
          </div>
          <footer>- 没有更多了，试试上面的产品吧 -</footer>
        </div>
        <div v-else-if="borrowList" class="none">
          <img src="./images/icon_yihan@2x.png" class="none-img" />
          <div class="none-title">很遗憾，暂时没有符合您的产品</div>
          <div class="none-next">下次再来逛逛吧～</div>
        </div>
      </div>
      <!-- 已申请产品 -->
      <applied v-else></applied>
    </pulldown-page>
    <!-- 返回弹窗 -->
    <nd-dialog v-model="toBack" :footer="false" closeBtn>
      <div class="logout-dialog">
        <div class="tong-guo">{{title }}</div>
        <main>
          <div class="middle">
            <img :src="riverData.icon" class="middle-img" />
            <span class="middle-productName">{{ riverData.productName }}</span>
            <div class="middle-cornerWord" v-if="riverData.cornerWord">
              {{ riverData.cornerWord }}
            </div>
          </div>
          <div class="e-du-gao-da">
            额度高达<span class="red">{{
              riverData.configLimit | toFixed
            }}</span>万
          </div>
          <div class="nian-hua-li-lv">
            年化利率 {{ riverData.minPrice }}%-{{ riverData.maxPrice }}%
          </div>
        </main>
        <div class="seize" @click="goToBack">立即尝试</div>
        <div class="give-up" @click="back(true)">放弃好运</div>
      </div>
    </nd-dialog>
  </div>
</template>
<script>
import { Swipe, SwipeItem } from 'vant'
import { mapActions } from 'vuex'
import { isEmptyObject, getKey } from '@/assets/utils'
import QuickList from '@/components/quick-list'

export default {
  name: 'river-diversion',
  customReadyNotify: true,
  components: {
    'van-swipe': Swipe,
    'van-swipe-item': SwipeItem,
    QuickList,
    applied: () => import('./components/applied.vue')
  },
  data () {
    return {
      borrowList: [], // 借款列表
      bannerList: [], // banner展示
      quickList: [], // icon列表
      toBack: false, // 返回弹窗
      riverData: {}, // 挽留弹窗数据
      tabActive: 0,
      title: '',
      findPopup: false // 挽留弹窗是否弹出过
    }
  },
  async created () {
    this.getBackData()
    const { tabActive } = this.$route.query
    if (tabActive) {
      this.tabActive = tabActive
    }
    // 现在未登录的也可以进来导流主页
    // const { from } = this.$route.query || {}
    // if (from === 'LANDING_RIVER') {
    //   const response = await this.getUserStatus()
    //   if (response.success) {
    //     const { jumpToLoanMarket } = response.data || {}
    //     if (!jumpToLoanMarket) {
    //       if (hasNativeMethod('navigateTo') && judgeClientSystem() !== 'IOS') {
    //         jsBridge('exit')
    //       } else {
    //         this.$router.push('/')
    //       }
    //     }
    //   }
    // }
    try {
      await this.init()
      this.$bus.$emit('ready')
    } catch (e) {
      this.$bus.$emit('ready')
    }
    this.$indicator.close()
  },
  watch: {
    toBack (value) {
      const { configId } = this.riverData || {}
      this.$report({
        id: 10290,
        args: {
          position: 'river_diversion',
          visible: value ? 1 : 0,
          screen: 'river_diversion',
          target: configId
        }
      })
    }
  },
  methods: {
    ...mapActions('user', [
      'getBorrowList',
      'getUserStatus',
      'getBorrowPopX',
      'getBorrowPopJumpX'
    ]),
    ...mapActions(['dataPoint']),
    // 处理标签
    dealWorld (cornerWord = '') {
      if (cornerWord) {
        return cornerWord.split(',')
      } else {
        return []
      }
    },
    // 抓住机会
    goToBack () {
      const { configId } = this.riverData || {}

      this.$sensors.track('Diversion_Click', { product_type: 'diversion', element_positon: 'product_pop', product_code: configId })
      this.toBack = false
      this.$report({
        id: 10291,
        args: {
          position: 'river_diversion_detail',
          status: 'hold',
          screen: 'river_diversion',
          target: configId
        }
      })
      this.dataPoint({
        id: 10291,
        position: 'river_diversion_detail',
        status: 'hold',
        screen: 'river_diversion',
        target: configId
      }) // 同步埋点
      // 后端埋点
      this.getBorrowPopJumpX({
        configId: this.riverData.configId
      })
      this.jumpMiddle(this.riverData)
    },
    // 初始化
    async init () {
      const showPlace =
        this.$route.query.from === 'LANDING_RIVER' ? 'SMS_MARKET_PAGE' : 'ALL'
      const response = await this.getBorrowList({
        version: 'V2',
        showPlace,
        queryBanner: true
      })
      if (response.success) {
        const {
          configs,
          icons,
          bannerConfigs,
          bannerConfigsV2
        } = response.data
        this.bannerList =
          (bannerConfigsV2 && bannerConfigsV2.length && bannerConfigsV2) ||
          bannerConfigs ||
          []
        this.borrowList = configs || []
        this.quickList = icons || []
        this.borrowList.map((item) => {
          this.$report({
            id: 10002,
            args: {
              screen: 'river_diversion_detail',
              position: 'river_diversion_detail',
              target: item.configId
            }
          })
        })
      }
    },
    // 获取返回弹窗数据
    async getBackData () {
      const { success, data } = await this.getBorrowPopX({
        popupType: 'DIVERSION_HOME_PAGE'
      })
      if (success && data && data.popups && data.popups.length) {
        this.riverData = data.popups[0]
        this.title = data.title || ''
      }
    },
    // 点击返回
    async detention () {
      if (!this.findPopup) {
        if (!isEmptyObject(this.riverData)) {
          this.findPopup = true
          this.toBack = true
          this.$sensors.track('Diversion_Exposure', { product_type: 'diversion', element_positon: 'product_pop', product_code: this.riverData.configId })
          return
        }
      }
      this.back(true)
    },
 
    // 下拉刷新
    onRefresh () {
      this.init()
    },
    // banner跳转
    jumpOutLink (item = {}) {
      const { config } = item
      if (!config) {
        return this.$router.push('/vip/index')
      }
      const token = getKey('userInfo', 'token')
      if (token) {
        this.$sensors.track('Diversion_Click', { product_type: 'diversion', element_positon: 'product_banner', product_code: config.configId })
        this.$report({
          id: 10269,
          args: {
            target: config.configId,
            screen: 'river_diversion_detail',
            step: 'banner'
          }
        })
        this.dataPoint({
          id: 10269,
          screen: 'river_diversion_detail',
          step: 'banner',
          target: config.configId
        })
        // 同步埋点
        this.jumpMiddle(config)
      } else {
        this.$router.push(`/landing/river?configId=${config.configId}`)
      }
    },
    // 去借款
    borrowMoney (item = {}, index) {
      const token = getKey('userInfo', 'token')
      if (token) {
        const { configId } = item
        this.$sensors.track('Diversion_Click', { product_type: 'diversion', element_positon: 'product_list', product_code: configId })
        this.$report({
          id: 10269,
          args: {
            screen: 'river_diversion_detail',
            status: 'borrowMoney',
            target: configId,
            position: this.$route.query.from,
            type: index
          }
        })
        this.dataPoint({
          id: 10269,
          screen: 'river_diversion_detail',
          status: 'borrowMoney',
          target: configId,
          position: this.$route.query.from,
          type: index
        }) // 同步埋点
        this.jumpMiddle(item)
      } else {
        this.$router.push(`/landing/river?configId=${item.configId}`)
      }
    },
    // 跳转中间界面
    jumpMiddle (item) {
      const { source } = this.$route.query || {}
      let sourceData = source ? { source } : {}
      const { configId, productName, logo, configLimit, needExLogin, autoJump, diversionMode } = item
      this.$router.push({
        path: '/river/middle',
        query: {
          configId,
          productName,
          logo,
          configLimit,
          needExLogin,
          autoJump,
          diversionMode,
          ...sourceData
        }
      })
    }
  }
}
</script>
<style>
.page {
  width: 750px;
  height: 100%;
  background: #F7F7F7;
  min-height: 100vh;
  /* overflow: scroll; */
}
</style>
<style scoped lang="less">
@import "../../../assets/less/mixin.less";

.red {
  color: #ff4633;
}
.river-index {
  width: 750px;
  height: 100%;
  background: white;
  overflow: scroll;
  /deep/.nd-navigation .center {
    margin-right: 0;
  }
  .service-icon {
    width: 40px;
    height: 40px;
    margin-right: 26px;
    vertical-align: -6px;
  }
  .banner {
    width: 690px;
    height: 250px;
    margin: 0 auto;
    margin-top: 30px;
    position: relative;
    border-radius: 20px;
    .van-swipe-item {
      width: 690px;
      height: 250px;
    }
    img {
      width: 100%;
      height: 100%;
    }

    .indicator {
      position: absolute;
      bottom: 16px;
      display: flex;
      flex-direction: row;
      left: 50%;
      transform: translateX(-50%);

      .indicator-item {
        width: 16px;
        height: 4px;
        background-color: #fff;
        opacity: 0.5;
        border-radius: 2px;

        & + .indicator-item {
          margin-left: 14px;
        }

        &.active {
          opacity: 1;
        }
      }
    }
  }
  .river {
    overflow: auto;
  }

  .tab-container {
    padding-top: 30px;
    display: flex;
    justify-content: space-around;
    .item {
      font-size: 28px;
      font-weight: 500;
      color: #999999;
      display: flex;
      align-items: center;
      padding: 20px;
      position: relative;
      .icon {
        width: 34px;
        height: 37px;
        background-size: contain !important;
        margin-right: 10px;
      }
      &.active {
        color: #ff4633;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        &:after {
          content: '';
          position: absolute;
          width: 140px;
          height: 6px;
          background: #FF4633;
          border-radius: 8px;
          bottom: 0px;
          left:50%;
          transform: translateX(-50%);
        }
      }
      &:nth-child(1) {
        .icon {
          background: url(./images/icon_youxuanhui.svg) no-repeat;
        }
        &.active {
          .icon {
            background: url(./images/icon_youxuanhong.svg) no-repeat;
          }
        }
      }
      &:nth-child(2) {
        &:after {
          left: 55%
        }
        .icon {
          background: url(./images/icon_yishenqinghui.svg) no-repeat;
        }
        &.active {
          .icon {
            background: url(./images/icon_yishenqinghong.svg) no-repeat;
          }
        }
      }
    }
  }

  .borrow {
    width: 690px;
    background: #fff;
    border-radius: 20px;
    padding: 50px 0 50px;
    margin: 30px auto 0;
    overflow: auto;
    main {
      .title {
        font-size: 38px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        display: flex;
        align-items: center;
        span {
          font-size: 24px;margin-left: 20px;
          font-weight: 400;
          color:#666;

        }
         border-bottom: 1px solid #eee;
         margin: 0 30px;
         padding-bottom: 10px;
      }
      .item {
        width: 630px;
        background: #ffffff; 
        margin: 20px auto 0;
        padding: 0 30px;
        border-bottom: 1px solid #eee;
        height: 220px;
        .top {
          height: 100px;
          
          display: flex;
          align-items: center;
          justify-content: space-between;
          &-left {
            display: flex;
            justify-content: space-between;
            align-items: center;
            &-more {
              margin-left: 14px;
              font-size: 28px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #333333;
              max-width: 250px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
            > img {
              width: 48px;
              height: 48px;
              border-radius: 10px;
            }
            &-border {
              margin-left: 10px;
              margin-right: 5px;
              max-width: 200px;
              line-height: 34px;
              text-align: center;
              border-radius: 4px;
              border: 1px solid #ff4633;
              font-size: 22px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #ff4633;
              padding: 0 5px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
          }
          &-right {
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
          }
        }
        .bottom {
          display: flex;
          justify-content: space-between;
          align-items:center;
            &-left-limit {
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              color: #999;
            }
            &-left-money {
              font-size: 40px;
              font-family: DIN-Medium, DIN;
              font-weight: 500;
              color: #333333;
            }
            &-left-label {
              color: #999;
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              p {
                color: #333;
                font-size: 24px;
                margin-top: 5px;
              }
            }
            .bottom-right {
                width: 170px;
                height: 60px;
                line-height: 60px;
                text-align: center;
                background: linear-gradient(90deg, #ff3333 0%, #ff5f34 100%);
                border-radius: 30px;
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #ffffff;
                height: 60px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              }
        }
      }
    }
  }
  .none {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 140px;
    // min-height:800px;
    &-img {
      width: 140px;
      height: 140px;
      display: block;
    }
    &-title {
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      margin-top: 40px;
    }
    &-next {
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      margin-top: 9px;
    }
  }
  footer {
    padding: 50px 0 75px;
    text-align: center;
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
  }
  .logout-dialog {
    padding: 60px 0 39px;
    font-family: PingFangSC-Regular, PingFang SC;
    .tong-guo {
      text-align: center;
      font-size: 36px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }
    main {
      padding: 0 0 0 90px;
      font-family: PingFangSC-Medium, PingFang SC;
      .middle {
        display: flex;
        align-items: center;
        margin: 84px 0 0 0;
        &-img {
          width: 48px;
          height: 48px;
          border-radius: 10px;
        }
        &-productName {
          max-width: 300px;
          height: 40px;
          font-size: 28px;
          font-weight: 500;
          color: #333333;
          line-height: 40px;
          margin-left: 12px;
          overflow: hidden; //溢出隐藏
          white-space: nowrap; //禁止换行
          text-overflow: ellipsis; //...
        }
        &-cornerWord {
          padding: 4px 10px;
          border-radius: 4px;
          border: 1px solid #ff4633;
          line-height: 34px;
          text-align: center;
          font-size: 22px;
          font-weight: 400;
          color: #ff4633;
          margin-left: 15px;
        }
      }
      .e-du-gao-da {
        height: 92px;
        font-size: 66px;
        font-weight: 500;
        color: #333333;
        line-height: 92px;
        margin-top: 19px;
        width: 410px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
      }
      .nian-hua-li-lv {
        height: 33px;
        font-size: 24px;
        font-weight: 400;
        color: #666666;
        line-height: 33px;
      }
      
    }
    .give-up {
      font-size: 24px;
      font-weight: 400;
      color: #999999;
      margin-top: 38px;
      text-align: center;
    }
    .seize {
      width: 440px;
      height: 80px;
      background: linear-gradient(90deg, #ff3333 0%, #ff5f34 100%);
      border-radius: 40px;
      font-size: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      text-align: center;
      margin: 69px auto 0;
      line-height: 80px;
    }
  }
}
</style>
